import { ReportMessageSource } from '@shared/utils/Enums/Constants';
import { ReportMessageTooltip } from '@shared/utils/ReportMessageTooltip';
import { TooltipType } from '@shared/utils/ReportMessageTooltipTypeEnum';
import { DataCache } from '../../DataCache';
export class TvNotificationManager {
    constructor(host) {
        this.host = host;
        DataCache.OnReportMessage.Subscribe(this.onReportMessage, this);
        DataCache.LoadAccountFollowerService();
    }
    onReportMessage(reportMessage) {
        if (!DataCache.Loaded) {
            return;
        }
        if (isNullOrUndefined(reportMessage)) {
            return;
        }
        if (reportMessage.SkipOnTicketViewer) {
            return;
        }
        if (reportMessage.source === ReportMessageSource.OpenOrderMessage) {
            return;
        }
        const reportTooltip = new ReportMessageTooltip(reportMessage);
        const header = reportTooltip.GetHeader();
        const text = reportTooltip.GetText();
        if (reportTooltip.TooltipDrawType === TooltipType.Refuse) {
            this.host.showNotification(header, text, 0 /* NotificationType.Error */);
        }
        else if (reportMessage.tooltipDrawType === TooltipType.FollowerInfo) {
            this.host.showNotification(header, text, 1 /* NotificationType.Success */);
        }
    }
    destroy() {
        DataCache.OnReportMessage.UnSubscribe(this.onReportMessage, this);
    }
}
